<template>
  <div
      class="checkbox"
      :class="isDisabledClassname"
  >
    <label :aria-label="ariaLabel">
      <input
          :disabled="locked || disabled"
          :checked="inputChecked"
          :indeterminate="isIndeterminate"
          type="checkbox"
          @input="toggleCheckbox"
      >
      <span :class="iconMods">
				<i class="fas fa-check-square"></i>
				<i class="far fa-square"></i>
			</span>
      <span v-if="name">{{ name }}</span>
    </label>
  </div>
</template>

<script setup>
import {computed} from 'vue';

const props = defineProps({
  name: {
    type: String
  },
  ariaLabel: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean
  },
  locked: {
    type: Boolean
  },
  checked: {
    type: Boolean,
  },
  list: {
    type: Array,
    default: () => []
  },
  value: {
    type: [String, Object, Array],
    default: null
  },
  indeterminate: {
    type: Boolean,
    default: false
  },
  useChangeEmit: {
    type: Boolean,
    default: false
  },
  iconMods: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['change-checked', 'update:list', 'update:checked'])

const inputChecked = computed(() => props.value ? props.list.includes(props.value) : props.checked);
const isDisabledClassname = computed(() => props.disabled ? "disabled" : "");
const isIndeterminate = computed(() => props.indeterminate ? props.checked === null : false);

function toggleCheckbox(event){
  if(props.locked || props.disabled) return false;
  // if checkbox part of a list of checkboxes
  if (props.value) {
    let updatedList = [...props.list];
    inputChecked.value
        ? updatedList.splice(updatedList.indexOf(props.value), 1)
        : updatedList.push(props.value)
    if(!props.useChangeEmit) emit('update:list', updatedList);
    if(props.useChangeEmit) emit('change-checked', updatedList);
  } else {
    // single checkbox
    const checkedPrev = props.checked;
    const checkedComputed = checkedPrev === true ? null : checkedPrev !== null;
    const checkedCurrent = props.indeterminate ? checkedComputed : event.target.checked;
    if(!props.useChangeEmit) emit('update:checked', checkedCurrent);
    if(props.useChangeEmit) emit('change-checked', checkedCurrent);
  }
}

</script>

<style lang="scss">
@use "@/scss/base/fields/checkbox";
</style>

